import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/logo.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UserIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import LockIcon from "@mui/icons-material/Lock";
import IconIncident from "@mui/icons-material/Campaign";
import IconMenu from "@mui/icons-material/Menu";
import IconClose from "@mui/icons-material/Close";
import ReportIncident from "../../pages/Incidents/ReportIncident";
import { hasAccess } from "../../app/utils";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../app/slices/authSlice";
import ChangePasswordDialog from "../../pages/Login/ChangePasswordDialog";
import coatOfArms from "../../assets/coat_of_arms.png";

const Header = () => {
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false);
  const { activeSession } = useSelector(({ auth }) => auth);

  const dispatch = useDispatch();

  //methods
  const getExpandedClass = () => {
    if (isOpenMenu) {
      return "main-nav-expanded";
    } else {
      return "";
    }
  };

  const getProfilePopupClass = () => {
    if (isOpenProfile) {
      return "profile-content-expanded";
    } else {
      return "";
    }
  };

  //builders
  const ListItem = ({ name, link, children = [] }) => {
    let _pathname = window.location.pathname;
    if (_pathname === "/") {
      _pathname = "/home";
    }
    if (_pathname === "/events/event-details") {
      _pathname = "/events";
    }
    if (_pathname === "/advisories/advisory-details") {
      _pathname = "/advisories";
    }
    if (_pathname === "/alerts/alert-details") {
      _pathname = "/alerts";
    }
    //helper method
    const _getActiveClass = () => {
      if (_pathname === link) {
        return "active-link";
      }

      if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (_pathname === child?.link) {
            return "active-link";
          }
        }
      } else {
        return "";
      }
    };

    return (
      <li key={`link-${name}`} className={_getActiveClass()}>
        <a href={link}>
          {name}
          {children.length > 0 && <ExpandMoreIcon />}
        </a>
        {children.length > 0 && (
          <ul className="collapse-nav">
            {children.map((child) => (
              <li
                className={
                  child?.link === window.location.pathname ? "active-link" : ""
                }
              >
                <a href={child?.link}>{child?.name}</a>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  const BuildMenuIcon = () => {
    return (
      <div
        className="menu-button"
        onClick={() => {
          setIsOpenMenu(!isOpenMenu);
        }}
      >
        <>
          {!isOpenMenu && <IconMenu />} {isOpenMenu && <IconClose />}
        </>
      </div>
    );
  };

  const BuildReportButton = () => {
    return (
      <div
        id="incident-link"
        onClick={() => {
          // if (activeSession?.session_token) {
          //   if (hasAccess("REPORT_INCIDENT")) {
          setIsOpenDialog(true);
          //   }
          // } else {
          //   window.location.replace("/login");
          // }
        }}
      >
        <IconIncident />
        REPORT INCIDENT
      </div>
    );
  };

  const BuildProfile = () => {
    return (
      <>
        {activeSession?.session_token && (
          <div className="profile-container">
            <div
              className="profile-button"
              onClick={() => {
                setIsOpenProfile(!isOpenProfile);
              }}
            >
              {!isOpenProfile ? <UserIcon /> : <IconClose />}
            </div>
            <div className={`profile-content ${getProfilePopupClass()}`}>
              <p>Logged in as</p>
              <p>
                <b>{activeSession?.full_name}</b>
              </p>
              <div
                className="mt-5 menu-item"
                onClick={() => {
                  setIsOpenProfile(false);
                  setIsOpenChangePassword(true);
                }}
              >
                <LockIcon />
                <div>Change Password</div>
              </div>
              <div
                className="mt-5 menu-item"
                onClick={() => {
                  dispatch(logout());
                }}
              >
                <LogoutIcon />
                <div>Logout</div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div className="header-banner">
        <div className="bg">
          <div className="coa">
            <img src={coatOfArms} alt="" />
          </div>
          <div className="logo">
            <a href="/">
              <img src={logo} alt="BOT" />
            </a>
          </div>
        </div>
      </div>
      <div className="header">
        <div className="left"></div>
        <div className="middle">
          <div className="title-long">
            Tanzania Financial Computer Emergency Response Team
          </div>
          <div className="title-short">TZ-FinCERT</div>
          <div className="top-nav">
            <ul className={`main-nav ${getExpandedClass()}`}>
              <ListItem link={"/home"} name={"Home"} />
              <ListItem
                link={"#"}
                name={"Services"}
                children={[
                  { name: "Advisories", link: "/advisories" },
                  { name: "Alerts", link: "/alerts" },
                  { name: "Reports", link: "/reports" },
                ]}
              />
              <ListItem link={"/about"} name={"About Us"} />
              <ListItem link={"/events"} name={"Events"} />
              <ListItem link={"/contacts"} name={"Contact Us"} />
              {hasAccess("PRIVATE_PAGES") && (
                <ListItem
                  link={"#"}
                  name={"Administration"}
                  children={[
                    {
                      name: "Incident Management",
                      link: "/incident-management",
                    },
                    {
                      name: "Advisory Management",
                      link: "/advisories/advisory-management",
                    },
                    {
                      name: "Alert Management",
                      link: "/alerts/alert-management",
                    },
                    {
                      name: "Report Management",
                      link: "/reports/report-management",
                    },
                    {
                      name: "Event Management",
                      link: "/events/event-management",
                    },
                    { name: "User Management", link: "/user-management" },
                  ]}
                />
              )}
            </ul>
          </div>
        </div>
        <div className="right">
          {BuildReportButton()}
          {BuildProfile()}
          {BuildMenuIcon()}
        </div>
      </div>

      {isOpenDialog && (
        <ReportIncident
          isOpen={isOpenDialog}
          handleClose={() => {
            setIsOpenDialog(false);
          }}
        />
      )}

      {isOpenChangePassword && (
        <ChangePasswordDialog
          isOpen={isOpenChangePassword}
          handleClose={() => {
            setIsOpenChangePassword(false);
          }}
        />
      )}
    </>
  );
};

export default Header;
